import { withRouter } from 'react-router-dom'
import React from 'react'
import cursorImg from '../cursor.png'
import pointerImg from '../pointer.png'


function Arrow ({ x, y, i }) {
  return (
    <img
      key={i}
      alt="arrow"
      style={{
        top: y,
        left: x,
        position: 'fixed',
        width: '10px',
        height: '20px',
        pointerEvents: 'none',
        zIndex: 12,
      }}
      src={cursorImg}
    />
  )
}
function Pointer ({ x, y, i }) {
  return (
    <img
      key={i}
      alt="pointer"
      style={{
        top: y,
        left: x,
        position: 'fixed',
        width: '14px',
        height: '18px',
        pointerEvents: 'none',
        zIndex: 12,
      }}
      src={pointerImg}
    />
  )
}

class Cursor extends React.Component {
  constructor (props) {
    super(props)
    const count = 7
    this.state = {
      mouse: [0, 0],
      cursors: [...new Array(count)].map(() => [0, 0]),
    }
  }

  _onMouseMove = e => {
    this.setState({ mouse: [e.x, e.y] })
  };
  _onClick = e => {
    this.setState({
      cursors: [...new Array(7)].map(() => [e.x, e.y]),
    })
  };

  componentDidMount () {
    window.onmousemove = this._onMouseMove
    window.onclick = this._onClick

    this.timerID = setInterval(() => this.ease(), 10)
  }

  componentWillUnmount () {
    clearInterval(this.timerID)
  }

  ease () {
    const { cursors, mouse } = this.state
    const [mouseX, mouseY] = mouse

    this.setState({
      cursors: cursors.map((cursor, i) => {
        const [x, y] = cursor
        const diffX = mouseX - x
        const diffY = mouseY - y

        const ease = (i + 1) * 5

        return [x + diffX / ease, y + diffY / ease, 1]
      }),
    })
  }

  render () {
    const { location } = this.props
    const { cursors } = this.state
    if (location.pathname === '/about') {
      return (
        <div className="cursor">
          {cursors.map(([x, y], i) => (
            <Pointer key={i} x={x} y={y} />
          ))}
          {this.props.children}
        </div>
      )
    }
    return (
      <div className="cursor pointer">
        {cursors.map(([x, y], i) => (
          <Arrow key={i} x={x} y={y} />
          ))}
        {this.props.children}
      </div>
    )
  }
}
export default withRouter(Cursor)



// WEBPACK FOOTER //
// /opt/build/repo/src/components/cursor.js